import React from 'react';
import { MicroscopeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-deep px-4 py-24 text-center text-white" data-id="element-61" data-mp="3n4w8ryifi9ie">
      <Reveal className="mx-auto max-w-3xl" data-id="element-62" data-mp="3s2xsmlnoicux">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-brand-lime/25 text-brand-lime" data-id="element-63" data-mp="welphkyr71w">
          <MicroscopeIcon className="h-7 w-7" aria-hidden="true" data-id="element-64" data-mp="2zeju84soheiu" />
        </div>
        <h2 className="mt-5 text-4xl font-black md:text-5xl" data-id="element-65" data-mp="34c27269tgdw4">Ready to Bring Biology to Every Classroom?</h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-66" data-mp="39beq0fxkh0tf">
          Start teaching a full year of clear, confident biology today.
        </p>
        <CTAButton className="mt-9 px-10 py-5 text-lg" data-id="element-67" data-mp="3e47zti7w6zcd">GET THE BIOLOGY READY PACK</CTAButton>
        <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-68" data-mp="2gl6irj4kk0tm">Instant access · 30-day guarantee</p>
      </Reveal>
    </section>;
}